<template>
  <div>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <h1 class="title">Storage Climbing Electronics</h1>
      <app-cells>
        <h2 class="title">Trackable items</h2>
        <app-button @click.native="onShowModal" size="small">Create</app-button>
      </app-cells>
      <v-client-table
        :data="table_trackable.items"
        :columns="table_trackable.columns"
        :options="table_trackable.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader_trackable }"
      >
        <template #number="{ row }">{{ row.number }}</template>
        <template #name="{ row }">{{ row.public_name }}</template>
        <template #status="{ row }">
        <span :style="{ 'backgroundColor': row.status.color }" class="status-tag">
          {{ row.status.name }}
        </span>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            @input="onClickPagination"
            v-if="pagination_trackable.pages > 1"
            v-model="pagination_trackable.page"
            :page-count="pagination_trackable.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_trackable.count" :count="table_trackable.items.length" :page="pagination_trackable.page" :limit="40" />
      </app-cells>
    </template>
    <modal
      name="item_modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      class="modal-not-overflow"
    >
      <div class="popup">
        <button @click="$modal.hide('item_modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Create</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm">
            <app-form-group label="Number" required>
              <app-input
                v-model="form.number"
                placeholder="Number"
                :error="$v.form.number.$error"
              />
              <template #error>
                <div v-if="$v.form.number.$dirty && !$v.form.number.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Item" required>
              <app-select
                v-model="form.item"
                :reduce="item => item.id"
                :options="item_options"
                placeholder="Item"
                :error="$v.form.item.$error"
              />
              <template #error>
                <div v-if="$v.form.item.$dirty && !$v.form.item.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Brand">
              <app-select
                v-model="form.brand"
                :reduce="item => item.id"
                :options="brand_options"
                placeholder="Brand"
              />
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button ref="submit" type="submit">Create</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import {
  getStorageItemsTrackableClimbingElectronics,
  getStorageItems,
  getStorageDictsBrand,
  postStorageItemsTrackable
} from '@/http'

export default {
  name: 'StorageClimbingElectronics',
  data() {
    return {
      page_loaded: false,
      item_options: [],
      brand_options: [],
      table_trackable: {
        items: [],
        columns: [
          'number',
          'name',
          'status',
        ],
        options: {
          headings: {
            'number': 'Number',
            'name': 'Name',
            'status': 'Status',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_trackable: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader_trackable: false,
      form: {},
    }
  },
  validations: {
    form: {
      item: { required },
      number: { required },
    }
  },
  created() {
    Promise.all([
      getStorageItems({trackable: true, active: true, section_slug: 'climbing-electronics'}),
      getStorageDictsBrand(),
      this.fetchItemsTrackable(),
    ])
      .then(response => {
        this.item_options = response[0].data
        this.brand_options = response[1].data
        this.page_loaded = true
      })
  },
  methods: {
    async fetchItemsTrackable() {
      this.table_preloader_trackable = true
      const response = await getStorageItemsTrackableClimbingElectronics({
        page: this.pagination_trackable.page,
        page_size: 40,
      })
      this.table_trackable.items = response.data.results
      this.pagination_trackable.pages = response.data.pages
      this.pagination_trackable.count = response.data.count
      this.table_preloader_trackable = false
    },
    onClickPagination(page) {
      this.pagination_trackable.page = page
      this.fetchItemsTrackable()
    },
    onShowModal() {
      this.form = {}
      this.$v.form.$reset()
      this.$modal.show('item_modal')
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      postStorageItemsTrackable(this.form)
        .then(() => {
          this.fetchItemsTrackable()
          this.$notify({
            type: 'success',
            title: 'Item created',
          })
          this.$modal.hide('item_modal')
        })
        .catch(() => { this.$refs.submit.preload = false })
    }
  }
}
</script>
